import { memo } from "react"
import type { Ref } from "react"
import { AutoAwesome } from "@mui/icons-material"
import { useScheduledWorkflowDeliverablesUnreadCount } from "resources/scheduled-workflows/hooks"
import Item from "./components/item"

function KellyNavItem({ onClick, ref }: { onClick?: () => void, ref?: Ref<HTMLElement> }) {
  const unreadReportCount = useScheduledWorkflowDeliverablesUnreadCount().data?.count ?? 0

  return <Item label="Kelly AI" MaterialIcon={AutoAwesome} to="kelly-ai" onClick={onClick} showBetaTag badgeCount={unreadReportCount} ref={ref} />
}

export default memo(KellyNavItem)
